import { render, staticRenderFns } from "./datos-generales.vue?vue&type=template&id=b9580110&scoped=true&"
import script from "./datos-generales.component.ts?vue&type=script&lang=ts&"
export * from "./datos-generales.component.ts?vue&type=script&lang=ts&"
import style0 from "./datos-generales.vue?vue&type=style&index=0&id=b9580110&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9580110",
  null
  
)

export default component.exports